'use client'

import type React from 'react'
import { useApp, useModals, useUser } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { OpenRegister } from '@/components/molecules'

interface OpenRegisterModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const OpenRegisterModal = ({ open }: OpenRegisterModalProps) => {
  const { closeModal } = useModals()
  const { setUserPin } = useUser()
  const { setIsLoading } = useApp()

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          setIsLoading(false)
          setUserPin([])
          closeModal('OPEN_REGISTER')
        }
      }}
    >
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('OPEN_REGISTER')}
        size="md"
      >
        <DialogHeader>
          <DialogTitle>Open Register</DialogTitle>
          <DialogDescription>
            Enter your opening balance to open the register
          </DialogDescription>
        </DialogHeader>

        {open && (
          <div className="flex h-full w-full">
            <OpenRegister />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
